import React, { useState, useEffect } from 'react';
import { IonButton, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import { mic, stopCircle, stopCircleSharp } from 'ionicons/icons';
import { Sound, convertBlobToSound } from './useRecorder';
import { _dict } from './constants';




async function processAudio(blob: Blob, maxDuration: number): Promise<{ base64: string; mimeType: string }> {
    // Load the audio buffer from the blob
    const arrayBuffer = await blob.arrayBuffer();
    const audioContext = new AudioContext();
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
  
    // Cut the audio to the given maxDuration if necessary
    let finalAudioBuffer: AudioBuffer;
    if (audioBuffer.duration > maxDuration) {
      const newDuration = maxDuration * audioBuffer.sampleRate;
      finalAudioBuffer = audioContext.createBuffer(
        audioBuffer.numberOfChannels,
        newDuration,
        audioBuffer.sampleRate
      );
      for (let i = 0; i < audioBuffer.numberOfChannels; i++) {
        finalAudioBuffer.copyToChannel(
          audioBuffer.getChannelData(i).subarray(0, newDuration),
          i,
          0
        );
      }
    } else {
      finalAudioBuffer = audioBuffer;
    }
  
  // Encode the processed audio data into a WAV Blob using a MediaRecorder
  const mediaStreamDestinationNode =audioContext.createMediaStreamDestination();
  const mediaRecorder =new MediaRecorder(mediaStreamDestinationNode.stream);
  const sourceNode =audioContext.createBufferSource();
  sourceNode.buffer =finalAudioBuffer;
  sourceNode.connect(mediaStreamDestinationNode);
  sourceNode.start();
  
  const chunks: BlobPart[] = [];
  mediaRecorder.ondataavailable =(e) => chunks.push(e.data);
  mediaRecorder.start();
  await new Promise((resolve) => setTimeout(resolve, finalAudioBuffer.duration *1000));
  mediaRecorder.stop();
  await new Promise((resolve) => (mediaRecorder.onstop =resolve));
  
  const mimeType ='audio/wav';
  const blobVar =new Blob(chunks, { type: mimeType });
  const reader =new FileReader();
  reader.readAsDataURL(blobVar);
  await new Promise((resolve) => (reader.onloadend =resolve));
  const base64 =(reader.result as string).split(',')[1];
  
  return { base64, mimeType };
  }
  
  
  
  interface VoiceRecorderProps {
    maxDuration?: number;
    onRecordingComplete?: (blob: Sound) => void;
    style?: any;
    lang: string;
  }
  

const VoiceRecorder: React.FC<VoiceRecorderProps> = ({ maxDuration = 4000, onRecordingComplete, style, lang  }) => {
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder>();
  const [recordingStartTime, setRecordingStartTime] = useState<number>();
  const [elapsedTime, setElapsedTime] = useState<number>(0);

  useEffect(() => {
    if (isRecording) {
      const timeoutId = setTimeout(() => {
        if (mediaRecorder) {
          mediaRecorder.stop();
          setMediaRecorder(undefined);
          setIsRecording(false);
        }
      }, maxDuration);
      return () => clearTimeout(timeoutId);
    }
  }, [isRecording, mediaRecorder, maxDuration]);

  useEffect(() => {
    let intervalId: NodeJS.Timeout;
    if (isRecording && recordingStartTime) {
      intervalId = setInterval(() => {
        setElapsedTime(Math.round((Date.now() - recordingStartTime) / 1000));
      }, 1000);
    }
    return () => {clearInterval(intervalId); setElapsedTime(0)};
  }, [isRecording, recordingStartTime]);

  const handleStartRecording = async () => {
    if (!navigator.mediaDevices) {
      console.error('Media devices not supported');
      return;
    }

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder = new MediaRecorder(stream);
    mediaRecorder.start();

    const chunks: BlobPart[] = [];
    mediaRecorder.ondataavailable = (e) => chunks.push(e.data);
    mediaRecorder.onstop = async () => {
      stream.getTracks().forEach((track) => track.stop());
      const blob = new Blob(chunks, { type: 'audio/mpeg' });
      
      // Cut silent parts from the recorded audio and limited its duration
      const processed = await processAudio(blob, maxDuration);
      //const processed = await convertBlobToSound(blob);

      // Call the onRecordingComplete callback function with the processed data
        if (onRecordingComplete) {
            onRecordingComplete(processed);
        }
    };

    setMediaRecorder(mediaRecorder);
    setIsRecording(true);
    setRecordingStartTime(Date.now());
  };

  const handleStopRecording = async () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setMediaRecorder(undefined);
      setIsRecording(false);
      setElapsedTime(0);
      setRecordingStartTime(undefined);
    }
  };

  return (
  <IonGrid style={{padding:"0px", marginTop:"0px"}}>


    <IonRow style={{padding:"0px", margin:"0px"}}>
      <IonCol style={{padding:"0px", textAlign:"center"}}>
        <IonButton
        onClick={() => {
            if (isRecording) {
            handleStopRecording();
            } else {
            handleStartRecording();
            }
        }}
        fill={isRecording ? "outline": "solid"}

        expand='block'
        style={style}
        color="light"
        >
          <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize:"18px"}}>
        
          {isRecording && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div
                style={{
                  backgroundColor: 'red',
                  borderRadius: '50%',
                  padding: '4px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  animation: 'blink 1s infinite',
                  border: '2px red solid',
                }}
              >
                <IonIcon size="small" icon={mic} style={{ fontSize: '18px', color: 'white' }} slot="start" />
              </div>
              <span
                style={{
                  marginLeft: '8px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: 'black',
                }}
              >
                {maxDuration / 1000 - elapsedTime}
              </span>
            </div>
          )}
        
        
        {isRecording === false ?
          <IonIcon
          slot="start"
          icon={isRecording ? stopCircleSharp : mic} 
          color={isRecording ? "danger" : undefined}
          style={{"color": isRecording ? undefined : "black"}}
          size="small"/>
        :null}
        
          {isRecording ? _dict.stop[lang] : _dict.record[lang]}
          </div>
        </IonButton>
        
      </IonCol>
    </IonRow>

    

  </IonGrid>

  );
};

export default VoiceRecorder;
